import { useEffect } from "react";
import { Observable } from "rxjs";

type useSubscriptionType = <T>(
  obs: Observable<T>,
  callbacks:
    { next?: (t: T) => void; complete?: () => void; error?: (err: unknown) => void } | ((t: T) => void),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any[],
) => void;

export const useSubscription: useSubscriptionType = (obs, callbacks, params) => {
  useEffect(() => {
    const sub = obs.subscribe(callbacks);
    return () => sub?.unsubscribe();
  }, [obs, ...(params || [])]);
};
